/**
 * The footer of the content pages (03 §0.4, §17): the rules (tarock.game's page; tile.game's index of its games'
 * rules) and credits, the legal pages, the other site (11 §8.6, platform Q9: once tile.game was open), a Buy Me a
 * Coffee button (a self-hosted image: the CSP allows no other origin's images) and the language switcher.
 */
import { t } from '@tarock/i18n';
import { LanguageSwitcher } from '../app/LanguageSwitcher';
import { SITE, siteHome } from '../app/site';

/** The Buy Me a Coffee page (Alexander's, as on moon.boston). */
export const COFFEE_URL = 'https://buymeacoffee.com/afalk';

/** Links to the rules, credits and legal pages, the other site and the coffee page; the language switcher. */
export function Footer() {
  return (
    <nav class="footer" aria-label={t('nav.footer')}>
      <div class="footer-links">
        <a href="/rules">{t('nav.rules')}</a>
        {SITE === 'tarock' && <a href="/credits">{t('nav.credits')}</a>}
        <a href="/legal/impressum">{t('legal.impressum.title')}</a>
        <a href="/legal/privacy">{t('legal.privacy.title')}</a>
        <a href="/legal/terms">{t('legal.terms.title')}</a>
        {SITE === 'tarock' ? (
          <a href={siteHome('tile')} data-testid="also-site">
            {t('nav.alsoTile')}
          </a>
        ) : (
          <a href={siteHome('tarock')} data-testid="also-site">
            {t('nav.alsoTarock')}
          </a>
        )}
      </div>
      {/* the second line: the language on the left, the coffee button centred (Alexander 2026-10-13) */}
      <div class="footer-tools">
        <LanguageSwitcher compact />
        <a class="coffee" href={COFFEE_URL} target="_blank" rel="noopener" data-testid="coffee">
          <img src="/bmc-button.png" alt={t('nav.coffee')} width={142} height={40} />
        </a>
      </div>
    </nav>
  );
}
